import { OptionsMap } from '../common';
import { TreeNode } from '../folder-navigation';
import { Permission } from '../role';
import { TokenData, initialTokenData } from './token-data.model';
import { UserState, initialUserState } from './user.model';
// PAGE STATE

export interface Extra {
    currentProductBcnFinalCode?: number;
    currentProdctMapfreId?: number;
    currentBcnDescription?: string;
    treeNode?: TreeNode[];
    pageIndex?: number;
}

export interface PageState {
    currentId: number;
    customerId?: number;
    collaboratorId?: number;
    personaId?: number;
    name: string;
    optionsMap: OptionsMap;
    extra?: Extra;
}

export interface CustomerState extends PageState {
    collaboratorId: number;
    personaId: number;
}

export interface Collaborator {
    collaboratorId: 0;
}

export interface Persona {
    personaId: 0;
}

export const initialPageState: PageState = {
    currentId: 0,
    customerId: 0,
    name: '',
    optionsMap: {},
    extra: {}
};

export enum PageStateEnum {
    AreaMarketingState = 'areaMarketingState',
    CustomerState = 'customerState',
    OfficeState = 'officeState',
    ConsultationState = 'consultationState',
    ReportState = 'reportState',
    DocumentState = 'documentState',
    ProcedureState = 'procedureState'
}

export enum TabEnum {
    Contract = 'contrato'
}

export interface NavigationState {
    backButton: BackButtonState;
}
export interface ConsultationState extends PageState {
    noticeCount: number;
    contractsCount: number;
}

export interface CustomerState extends PageState {
    collaboratorId: number;
}

export interface BackButtonState {
    text: string;
    url: string;
    leadingText?: string;
    leadingAdditionalInfo?: string;
    leadingUrl?: string;
    additionalInfo?: string;
    routeInfo?: string;
}

export const initialBackButtonState: BackButtonState = {
    text: '',
    url: '',
    leadingText: '',
    leadingAdditionalInfo: '',
    leadingUrl: '',
    additionalInfo: '',
    routeInfo: ''
};

// APP STATE
export interface AppState {
    isLoading: boolean;
    tokenData: TokenData;
    userState: UserState;
    customerState: PageState;
    officeState: PageState;
    documentState: PageState;
    navigation: NavigationState;
    areaMarketingState: PageState;
    consultationState: ConsultationState;
    reportState: PageState;
    procedureState: PageState;
    permissionData: Permission[];
    permission: Permission;
}

export const initialPermissionData = [];

export const initialPermission = {} as Permission;

export const initialState: AppState = {
    isLoading: false,
    tokenData: initialTokenData,
    userState: initialUserState,
    customerState: initialPageState,
    officeState: initialPageState,
    documentState: initialPageState,
    areaMarketingState: initialPageState,
    consultationState: { ...initialPageState, noticeCount: 0, contractsCount: 0 },
    reportState: initialPageState,
    procedureState: initialPageState,
    permissionData: initialPermissionData,
    navigation: {
        backButton: initialBackButtonState
    },
    permission: initialPermission
};

// PAGES
export enum RouteEnum {
    Customers = 'clientes',
    Offices = 'sucursales',
    Detail = 'detalle',
    NewCustomer = '/clientes/detalle',
    NewOffice = '/sucursales/detalle',
    Contract = 'contrato',
    Reports = 'informes',
    Comercial = 'comercial'
}
